const getUrlParam = (search, key) => {
    const queryParams = new URLSearchParams(search);
    return queryParams.get(key);
}

const UrlHelper = {
    getUrlParam
}

export default UrlHelper;